var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-player player"},[_vm._v("\n    "+_vm._s(_vm.$t('player.not_supported'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }